module.exports = __webpack_public_path__ + "img/closered.162602bc.png";